import { render, staticRenderFns } from "./xskUploadQn.vue?vue&type=template&id=3dec29b2"
import script from "./xskUploadQn.vue?vue&type=script&lang=js"
export * from "./xskUploadQn.vue?vue&type=script&lang=js"
import style0 from "./xskUploadQn.vue?vue&type=style&index=0&id=3dec29b2&prod&lang=css"
import style1 from "./xskUploadQn.vue?vue&type=style&index=1&id=3dec29b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports